module.exports = __webpack_public_path__ + "static/media/intro_icon_6.4db2965e.svg";